import { useRegionStore } from '@/store/region'

import { currencyIdNewUserGiftMap, DEFAULT_CURRENCY_ID } from '@/constants/currency'
import { localeSmartBannerPhoneMap } from '@/constants/banner'
import { DEFAULT_LANG_CODE } from '@/constants/locales'

export function useNewUserGift() {
  const { t, locale } = useI18n()

  const regionStore = useRegionStore()

  const amount = computed(() => currencyIdNewUserGiftMap[regionStore.currentRegion?.currency_id ?? DEFAULT_CURRENCY_ID])
  const downloadPromoText = computed(() => {
    return t('smart.banner.content', { amount: amount.value })
  })

  const smartBannerImgPath = computed(() => {
    return locale.value in localeSmartBannerPhoneMap
      ? localeSmartBannerPhoneMap[locale.value as keyof typeof localeSmartBannerPhoneMap]
      : localeSmartBannerPhoneMap[DEFAULT_LANG_CODE]
  })

  return {
    downloadPromoText,
    smartBannerImgPath,
  }
}
